import React from 'react'
import {Header} from "semantic-ui-react";

const Complete = (props) => {
    return (
        <div>
            <Header as='h2'>Registration Complete</Header>
            <div>
                <p><strong>Thank you! You have successfully completed the registration process.</strong></p>

                <h4>IMPORTANT: IF YOU ARE A CB AUDITOR CANDIDATE, YOU WILL NOT RECEIVE ACCESS TO THE ADP UNTIL YOUR CB APPROVES YOUR SPONSORSHIP REQUEST.</h4>

                <p>For CB Auditors Candidates to receive access to the ADP, your sponsoring CB must first approve your sponsorship request.
                    Your CB may then either pay for your Initial Annual Fee, or choose to forward the payment to you.
                    You will be notified by Email automatically in either case.  <strong>You cannot pay for your Initial Annual Fee unless your CB first gives that option to you in the ADP.</strong>
                </p>

                <p>If you are a "free ticket" candidate (non-auditor, veto power, witness auditor, etc.) and do not perform third-party audits, your access has been granted without requiring any further approval or payment.</p>

                <br /><p>For ADP Technical Support, please contact <a href="mailto:&#116;&#101;&#099;&#104;&#115;&#117;&#112;&#112;&#111;&#114;&#116;&#064;&#105;&#097;&#116;&#102;&#097;&#100;&#112;&#046;&#099;&#111;&#109;">&#116;&#101;&#099;&#104;&#115;&#117;&#112;&#112;&#111;&#114;&#116;&#064;&#105;&#097;&#116;&#102;&#097;&#100;&#112;&#046;&#099;&#111;&#109;</a>.  For inquiries related to your ADP sponsorship status, please contact your CB.</p>

                <br /><p><a href="http://www.iatfglobaloversight.org">IATF Global Oversight Website</a></p>
            </div>

        </div>
    )
}

export default Complete;